{
  "title": "True Strike",
  "source": "Player's Handbook",
  "levelAndSchool": "Divination cantrip",
  "level": 0,
  "castingTime": "1 action",
  "range": "30 feet",
  "components": "S",
  "duration": "Concentration, up to 1 round",
  "description": [
    "You extend your hand and point a finger at a target in range. Your magic grants you a brief insight into the target’s defenses. On your next turn, you gain advantage on your first attack roll against the target, provided that this spell hasn’t ended."
  ],
  "spellLists": ["bard", "eldritch-knight", "arcane-trickster", "sorcerer", "warlock", "wizard"]
}
